export default __webpack_public_path__ + "static/media/logo.54d93a78.svg";